// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__2-sZY","withMobileMargins":"DateRangeInput_withMobileMargins__uP0rx","arrowIcon":"DateRangeInput_arrowIcon__1QYBu"};